import { Injectable } from '@angular/core';

@Injectable()
export class FormioAppConfig {
  appUrl: string = '';
  apiUrl: string = '';
  icons?: string;
  formOnly?: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/formio.config.ts